import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableCell = styled(TableCell)(() => ({
  border: '1px solid rgba(224, 224, 224, 1) ',
  textAlign: 'center',
}));
